import * as React from "react";

export default function StartVideoConsultation({
  videoConsultationURL,
}: {
  videoConsultationURL: string;
}) {
  return (
    <a className="button-primary" href={videoConsultationURL} target="_blank">
      <i className="ic_video" />
      <span>{i18n["Page.PatientManagement.StartVideoConsultation"]}</span>
    </a>
  );
}
